export const FULLSTORY_ORG_ID = 'o-1W3ZCW-na1';
